import React, { FunctionComponent, useContext } from 'react';
import { ColorsContext } from '../../context/ColorsContext';
import { Link } from '../Link/Link';
import {
  facebookIcon,
  twitterIcon,
  instagramIIcon,
  youtubeIcon,
  linkedinIcon,
  globeIcon,
} from '@justgiving/icons';
import Svg from '@justgiving/svg';

import styles from './CharitySocialLinks.scss';

interface SocialLinksProps {
  socialLinks: {
    type?: string | null;
    url?: string | null;
  }[];
}

export const mapSocialTypeToIcon = (socialType: string) => {
  switch (socialType) {
    case 'facebook':
      return facebookIcon;
    case 'instagram':
      return instagramIIcon;
    case 'twitter':
      return twitterIcon;
    case 'youtube':
      return youtubeIcon;
    case 'linkedin':
      return linkedinIcon;
    default:
      return globeIcon;
  }
};

const CharityLinks: FunctionComponent<SocialLinksProps> = ({ socialLinks }) => {
  const foregroundColor =
    useContext(ColorsContext)?.foregroundColor || '#000000';
  const backgroundcolor =
    useContext(ColorsContext)?.backgroundColor || '#ffffff';

  return (
    <>
      <h2 className="jg-h5 jg-space-mvmd" style={{ color: foregroundColor }}>
        Charity links
      </h2>
      <ul className={styles.socialLinks}>
        {socialLinks?.map(
          (socialLink, index) =>
            socialLink.url &&
            socialLink.type && (
              <li key={index} className="jg-space-mrsm">
                <Link href={socialLink.url}>
                  <Svg
                    markup={mapSocialTypeToIcon(socialLink.type)}
                    className={styles.icon}
                    style={{
                      background: foregroundColor,
                      fill: backgroundcolor,
                    }}
                  />
                </Link>
              </li>
            ),
        )}
      </ul>
    </>
  );
};

export default CharityLinks;
